import React from "react";
import { useTranslation } from "react-i18next";

import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";

export default function Hconsolidated() {
  const { t } = useTranslation("help");

  return (
    <div className="theme-whbl">
      {/* Internal CSS matching AIEndpointOverview pattern */}
      <style>
        {`
          .help-row {
            display: block;
            gap: 16px;
            padding: 16px 18px;
            border-bottom: 1px solid #374151;
            align-items: flex-start;
          }

          .help-row:last-child {
            border-bottom: none;
          }

          .help-row p {
            width: 100%;
            max-width: 100%;
            margin: 0 0 10px 0;
            font-size: 14px;
            line-height: 1.6;
            color: #e5e7eb;
          }

          .help-row img {
            width: 100%;
            max-width: 600px;
            border-radius: 6px;
            padding: 10px;
            margin: 10px 0;
            background: #111827;
            border: 1px solid #374151;
          }

          .doc-subheading {
            color: #f5f5f5;
            font-size: 15px;
            font-weight: 600;
            margin-top: 16px;
            margin-bottom: 8px;
          }

          .doc-list {
            margin-top: 0;
            margin-bottom: 12px;
            padding-left: 20px;
            font-size: 14px;
            color: #e5e7eb;
          }

          .doc-list li {
            margin-bottom: 6px;
          }

          .sub-method {
            margin-left: 12px;
            margin-bottom: 20px;
            padding-left: 12px;
            border-left: 2px solid #374151;
          }

          @media (max-width: 768px) {
            .help-row {
              flex-direction: column;
            }
          }
        `}
      </style>

      <div className="container-fluid">
        <div className="main-container">
          <main style={{ width: "100%" }}>
            <div className="dashboard">

              {/* Title Section */}
              <div className="pm-header">
                <h1 className="pm-title">{t("Hconsolidated.mainTitle")}</h1>
                <p style={{ color: "#60a5fa", fontSize: "15px", fontWeight: 600, marginTop: "4px", marginBottom: "0" }}>
                  {t("subtitle")}
                </p>
              </div>

              {/* Content Container */}
              <div
                style={{
                  backgroundColor: "#10172a",
                  borderRadius: "6px",
                  marginTop: "15px",
                  overflow: "hidden",
                  border: "1px solid #374151"
                }}
              >
                {/* Section 1: Overview */}
                <div className="help-row">
                  <h2 style={{ color: "#ffffff", fontSize: "18px", fontWeight: 600, marginTop: "0", marginBottom: "12px", borderBottom: "1px solid #374151", paddingBottom: "6px" }}>
                    {t("Hconsolidated.sections.overview.title")}
                  </h2>
                  <p>{t("Hconsolidated.sections.overview.text")}</p>
                  <img     className="help-img"   src={t("Hconsolidated.image")}       />
                  
                </div>

                {/* Section 2: Opening Consolidate Reports */}
                <div className="help-row">
                  <h2 style={{ color: "#ffffff", fontSize: "18px", fontWeight: 600, marginTop: "0", marginBottom: "12px", borderBottom: "1px solid #374151", paddingBottom: "6px" }}>
                    {t("Hconsolidated.sections.opening.title")}
                  </h2>
                  <ol className="doc-list" style={{ listStyleType: "decimal" }}>
                    <li>{t("Hconsolidated.sections.opening.steps.0")}</li>
                    <li>{t("Hconsolidated.sections.opening.steps.1")}</li>
                    <li>{t("Hconsolidated.sections.opening.steps.2")}</li>
                    <li>{t("Hconsolidated.sections.opening.steps.3")}</li>
                    <li>{t("Hconsolidated.sections.opening.steps.4")}</li>
                    <li>{t("Hconsolidated.sections.opening.steps.5")}</li>
                    <li>{t("Hconsolidated.sections.opening.steps.6")}</li>
                  </ol>
                  <p>{t("Hconsolidated.sections.opening.resultText")}</p>
                </div>

                {/* Section 3: Report Name */}
                <div className="help-row">
                  <h2 style={{ color: "#ffffff", fontSize: "18px", fontWeight: 600, marginTop: "0", marginBottom: "12px", borderBottom: "1px solid #374151", paddingBottom: "6px" }}>
                    {t("Hconsolidated.sections.reportName.title")}
                  </h2>
                  <p>{t("Hconsolidated.sections.reportName.text")}</p>
                </div>

                {/* Section 4: Consolidation Methods */}
                <div className="help-row">
                  <h2 style={{ color: "#ffffff", fontSize: "18px", fontWeight: 600, marginTop: "0", marginBottom: "12px", borderBottom: "1px solid #374151", paddingBottom: "6px" }}>
                    {t("Hconsolidated.sections.methods.title")}
                  </h2>
                  <p>{t("Hconsolidated.ections.methods.intro")}</p>

                  <div className="sub-method">
                    <img src={t("Hconsolidated.image2")}   alt="Consolidated Report" />
                    <h3 className="doc-subheading">{t("sections.methods.aggregate.title")}</h3>
                    <p><strong>{t("Hconsolidated.Hconsolidated.labels.description")}</strong> {t("Hconsolidated.sections.methods.aggregate.description")}</p>
                    <p><strong>{t("Hconsolidated.labels.whenToUse")}</strong> {t("Hconsolidated.sections.methods.aggregate.whenToUse")}</p>
                    <p><strong>{t("Hconsolidated.labels.expectedResult")}</strong> {t("Hconsolidated.sections.methods.aggregate.expectedResult")}</p>
                  </div>

                  <div className="sub-method">
                    <h3 className="doc-subheading">{t("sections.methods.latest.title")}</h3>
                    <p><strong>{t("Hconsolidated.labels.description")}</strong> {t("Hconsolidated.sections.methods.latest.description")}</p>
                    <p><strong>{t("Hconsolidated.labels.whenToUse")}</strong> {t("Hconsolidated.sections.methods.latest.whenToUse")}</p>
                    <p><strong>{t("Hconsolidated.labels.expectedResult")}</strong> {t("Hconsolidated.sections.methods.latest.expectedResult")}</p>
                  </div>

                  <div className="sub-method">
                    <h3 className="doc-subheading">{t("Hconsolidated.sections.methods.oldest.title")}</h3>
                    <p><strong>{t("Hconsolidated.labels.description")}</strong> {t("Hconsolidated.sections.methods.oldest.description")}</p>
                    <p><strong>{t("Hconsolidated.labels.whenToUse")}</strong> {t("Hconsolidated.sections.methods.oldest.whenToUse")}</p>
                    <p><strong>{t("Hconsolidated.labels.expectedResult")}</strong> {t("Hconsolidated.sections.methods.oldest.expectedResult")}</p>
                  </div>

                  <div className="sub-method">
                    <h3 className="doc-subheading">{t("Hconsolidated.sections.methods.highSeverity.title")}</h3>
                    <p><strong>{t("Hconsolidated.labels.description")}</strong> {t("Hconsolidated.sections.methods.highSeverity.description")}</p>
                    <p><strong>{t("Hconsolidated.labels.whenToUse")}</strong> {t("Hconsolidated.sections.methods.highSeverity.whenToUse")}</p>
                    <p><strong>{t("Hconsolidated.labels.expectedResult")}</strong> {t("Hconsolidated.sections.methods.highSeverity.expectedResult")}</p>
                  </div>

                  <div className="sub-method">
                    <h3 className="doc-subheading">{t("Hconsolidated.sections.methods.failedTests.title")}</h3>
                    <p><strong>{t("Hconsolidated.labels.description")}</strong> {t("Hconsolidated.sections.methods.failedTests.description")}</p>
                    <p><strong>{t("Hconsolidated.labels.whenToUse")}</strong> {t("Hconsolidated.sections.methods.failedTests.whenToUse")}</p>
                    <p><strong>{t("Hconsolidated.labels.expectedResult")}</strong> {t("Hconsolidated.sections.methods.failedTests.expectedResult")}</p>
                    <img src={t("Hconsolidated.image3")}   alt="Consolidated Report" />
                    <img src={t("Hconsolidated.image4")}   alt="Consolidated Report" />
                  </div>
                </div>

                {/* Section 5: Consolidation Method Comparison Table */}
                <div className="help-row">
                  <h2 style={{ color: "#ffffff", fontSize: "18px", fontWeight: 600, marginTop: "0", marginBottom: "12px", borderBottom: "1px solid #374151", paddingBottom: "6px" }}>
                    {t("Hconsolidated.sections.comparison.title")}
                  </h2>
                  <div className="dark-table-container">
                    <table className="dark-guide-table">
                      <thead>
                        <tr>
                          <th>{t("Hconsolidated.sections.comparison.headers.method")}</th>
                          <th>{t("Hconsolidated.sections.comparison.headers.purpose")}</th>
                          <th>{t("Hconsolidated.sections.comparison.headers.recommendedUse")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{t("Hconsolidated.sections.comparison.rows.0.method")}</td>
                          <td>{t("Hconsolidated.sections.comparison.rows.0.purpose")}</td>
                          <td>{t("Hconsolidated.sections.comparison.rows.0.recommendedUse")}</td>
                        </tr>
                        <tr>
                          <td>{t("Hconsolidated.sections.comparison.rows.1.method")}</td>
                          <td>{t("Hconsolidated.sections.comparison.rows.1.purpose")}</td>
                          <td>{t("Hconsolidated.sections.comparison.rows.1.recommendedUse")}</td>
                        </tr>
                        <tr>
                          <td>{t("Hconsolidated.sections.comparison.rows.2.method")}</td>
                          <td>{t("Hconsolidated.sections.comparison.rows.2.purpose")}</td>
                          <td>{t("Hconsolidated.sections.comparison.rows.2.recommendedUse")}</td>
                        </tr>
                        <tr>
                          <td>{t("Hconsolidated.sections.comparison.rows.3.method")}</td>
                          <td>{t("Hconsolidated.sections.comparison.rows.3.purpose")}</td>
                          <td>{t("Hconsolidated.sections.comparison.rows.3.recommendedUse")}</td>
                        </tr>
                        <tr>
                          <td>{t("Hconsolidated.sections.comparison.rows.4.method")}</td>
                          <td>{t("Hconsolidated.sections.comparison.rows.4.purpose")}</td>
                          <td>{t("Hconsolidated.sections.comparison.rows.4.recommendedUse")}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Section 6: Recommended Workflow */}
                <div className="help-row">
                  <h2 style={{ color: "#ffffff", fontSize: "18px", fontWeight: 600, marginTop: "0", marginBottom: "12px", borderBottom: "1px solid #374151", paddingBottom: "6px" }}>
                    {t("Hconsolidated.sections.workflow.title")}
                  </h2>
                  <ol className="doc-list" style={{ listStyleType: "decimal" }}>
                    <li>{t("Hconsolidated.sections.workflow.steps.0")}</li>
                    <li>{t("Hconsolidated.sections.workflow.steps.1")}</li>
                    <li>{t("Hconsolidated.sections.workflow.steps.2")}</li>
                    <li>{t("Hconsolidated.sections.workflow.steps.3")}</li>
                    <li>{t("Hconsolidated.sections.workflow.steps.4")}</li>
                    <li>{t("Hconsolidated.sections.workflow.steps.5")}</li>
                    <li>{t("Hconsolidated.sections.workflow.steps.6")}</li>
                    <li>{t("Hconsolidated.sections.workflow.steps.7")}</li>
                  </ol>
                </div>

                {/* Section 7: Choosing the Right Method Table */}
                <div className="help-row">
                  <h2 style={{ color: "#ffffff", fontSize: "18px", fontWeight: 600, marginTop: "0", marginBottom: "12px", borderBottom: "1px solid #374151", paddingBottom: "6px" }}>
                    {t("Hconsolidated.sections.choosingMethod.title")}
                  </h2>
                  <div className="dark-table-container">
                    <table className="dark-guide-table">
                      <thead>
                        <tr>
                          <th>{t("Hconsolidated.sections.choosingMethod.headers.requirement")}</th>
                          <th>{t("Hconsolidated.sections.choosingMethod.headers.recommendedMethod")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{t("Hconsolidated.sections.choosingMethod.rows.0.requirement")}</td>
                          <td>{t("Hconsolidated.sections.choosingMethod.rows.0.recommendedMethod")}</td>
                        </tr>
                        <tr>
                          <td>{t("Hconsolidated.sections.choosingMethod.rows.1.requirement")}</td>
                          <td>{t("Hconsolidated.sections.choosingMethod.rows.1.recommendedMethod")}</td>
                        </tr>
                        <tr>
                          <td>{t("Hconsolidated.sections.choosingMethod.rows.2.requirement")}</td>
                          <td>{t("Hconsolidated.sections.choosingMethod.rows.2.recommendedMethod")}</td>
                        </tr>
                        <tr>
                          <td>{t("Hconsolidated.sections.choosingMethod.rows.3.requirement")}</td>
                          <td>{t("Hconsolidated.sections.choosingMethod.rows.3.recommendedMethod")}</td>
                        </tr>
                        <tr>
                          <td>{t("Hconsolidated.sections.choosingMethod.rows.4.requirement")}</td>
                          <td>{t("Hconsolidated.sections.choosingMethod.rows.4.recommendedMethod")}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Section 8: Important Considerations */}
                <div className="help-row">
                  <h2 style={{ color: "#ffffff", fontSize: "18px", fontWeight: 600, marginTop: "0", marginBottom: "12px", borderBottom: "1px solid #374151", paddingBottom: "6px" }}>
                    {t("Hconsolidated.sections.considerations.title")}
                  </h2>
                  <ul className="doc-list" style={{ listStyleType: "disc" }}>
                    <li>{t("Hconsolidated.sections.considerations.list.0")}</li>
                    <li>{t("Hconsolidated.sections.considerations.list.1")}</li>
                    <li>{t("Hconsolidated.sections.considerations.list.2")}</li>
                    <li>{t("Hconsolidated.sections.considerations.list.3")}</li>
                    <li>{t("Hconsolidated.sections.considerations.list.4")}</li>
                    <li>{t("Hconsolidated.sections.considerations.list.5")}</li>
                    <li>{t("Hconsolidated.sections.considerations.list.6")}</li>
                    <li>{t("Hconsolidated.sections.considerations.list.7")}</li>
                  </ul>
                </div>

                {/* Section 9: Summary */}
                <div className="help-row">
                  <h2 style={{ color: "#ffffff", fontSize: "18px", fontWeight: 600, marginTop: "0", marginBottom: "12px", borderBottom: "1px solid #374151", paddingBottom: "6px" }}>
                    {t("Hconsolidated.sections.summary.title")}
                  </h2>
                  <p>{t("Hconsolidated.sections.summary.text")}</p>
                </div>

              </div>
            </div>
          </main>
        </div>
      </div>

      {/* Shared Dark Table Styles matching AIEndpointOverview */}
      <style>{`
        .dark-table-container {
          width: 100%;
          margin: 15px 0;
          overflow-x: auto;
          background: #111827;
          padding: 0;
          box-sizing: border-box;
        }

        .dark-guide-table {
          width: 100%;
          border-collapse: collapse;
          font-family: "Segoe UI", Arial, sans-serif;
          font-size: 14px;
          color: #e5e7eb;
          background: #111827;
          border: 1px solid #374151;
        }

        .dark-guide-table thead th {
          background: #1f2937;
          color: #60a5fa;
          font-weight: 700;
          text-align: left;
          padding: 12px 14px;
          border: 1px solid #4b5563;
          vertical-align: middle;
        }

        .dark-guide-table tbody td {
          background: #111827;
          color: #e5e7eb;
          padding: 12px 14px;
          border: 1px solid #374151;
          vertical-align: top;
          line-height: 1.55;
        }

        .dark-guide-table tbody tr:nth-child(even) td {
          background: #172033;
        }

        .dark-guide-table tbody tr:hover td {
          background: #1e293b;
        }

        @media (max-width: 768px) {
          .dark-guide-table {
            min-width: 650px;
          }
        }
      `}</style>
    </div>
  );
}